import type { ScopeFilter } from '@@/api/health';
import type { ProgramAnalyticsManager, ProgramWindow } from '@/state/program/useProgramAnalytics';
import { PROGRAM_WINDOWS } from '@/state/program/useProgramAnalytics';
import { PillTabs, ScopePills } from '../ConsolePanel';

export type HeaderProps = { manager: ProgramAnalyticsManager };

const WINDOW_OPTIONS = PROGRAM_WINDOWS.map((months) => ({ label: `${months} months`, value: String(months) }));

/** The same scope strip as Health and Performance, plus the window this page adds. */
export const Header = ({ manager }: HeaderProps) => {
  const { scope, setScope, months, setMonths, isAgency } = manager;

  return (
    <div className="bg-panel border-line flex flex-col gap-2 rounded-panel border px-3.5 py-2.5 md:flex-row md:flex-wrap md:items-center md:justify-between md:gap-3">
      <ScopePills value={scope} onChange={(next) => setScope(next as ScopeFilter)} isAgency={isAgency} />
      {/* Wrapped only to carry the tour anchor; min-w-0 keeps the strip's own sideways scroll on a phone. */}
      <div className="min-w-0" data-tour="program-window">
        <PillTabs
          options={WINDOW_OPTIONS}
          value={String(months)}
          onChange={(next) => setMonths(Number(next) as ProgramWindow)}
        />
      </div>
    </div>
  );
};
